export default __webpack_public_path__ + "static/media/phoneoff.37ba178f.svg";